<template>
  <div class="icon-container" :title="toggleLabel" :aria-label="toggleLabel" :aria-expanded="opened" aria-keyshortcuts="Alt+T" role="button" tabindex="0" @click="iconclick" @keydown.enter.prevent="iconclick" @keydown.space.prevent="iconclick">
    <svg-icon :icon="icon"></svg-icon>
  </div>
</template>
<script lang="ts">
import store from '@/store'
import { computed, defineComponent, onMounted, onBeforeUnmount } from 'vue'
import { isSidebarToggleShortcut } from '@/utils/sidebarToggleShortcut'
export default defineComponent({
  setup(){
    const opened = computed(() => store.getters.sideBarOpened)
    const toggleLabel = computed(() => `${opened.value ? '收起' : '展开'}左侧导航（Alt+T）`)
    const iconclick = () => {
      //sideBarWidth.value=store.getters.sideBarOpened?210:80
      store.commit('app/openSidebar')
      
    }
    const icon = computed(() => {
      return store.getters.sideBarOpened ? 'hamburger-opened' : 'hamburger-closed'
    })
    const onShortcut = (event: KeyboardEvent) => {
      if (!store.getters.token || !isSidebarToggleShortcut(event, true)) return
      event.preventDefault()
      event.stopPropagation()
      if (!event.repeat) iconclick()
    }
    onMounted(() => window.addEventListener('keydown', onShortcut, true))
    onBeforeUnmount(() => window.removeEventListener('keydown', onShortcut, true))
    return {
      iconclick,icon,opened,toggleLabel
    }
  }
})

</script>
<style lang="scss" scoped>

.icon-container {
  cursor: pointer;
  padding: 0 5px;
  // width: 25px;
  font-size: 24px;
  transition: background 0.5s;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
